module.exports = __webpack_public_path__ + "img/bg11.be265d8b.png";